import React from 'react';
import { Hero } from '../components/Hero';
import { WhyUs } from '../components/WhyUs';
import { Services } from '../components/Services';
import { HowItWorks } from '../components/HowItWorks';
import { FAQ } from '../components/FAQ';
import { Reviews } from '../components/Reviews';
import { CtaBanner } from '../components/CtaBanner';
export function Home() {
  return <main data-id="element-1819">
      <Hero data-id="element-1820" />
      <WhyUs data-id="element-1821" />
      <Services data-id="element-1822" />
      <HowItWorks data-id="element-1823" />
      <FAQ data-id="element-1824" />
      <Reviews data-id="element-1825" />
      <CtaBanner data-id="element-1826" />
    </main>;
}